import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import '../../../css/MarketPlace/ServiceSelection.css';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import rightarrow from '../../../Assets/ContainerStatus/Assets_Desktop/arrow-right-red.svg';
import quotationHistory from '../../../Assets/MarketPlace/quotationHistory.svg';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceBaseURL, servicecatalogBaseURL } from '../../../Services/config/apiGateway';
import { SERVICE_TYPES_ENDPOINT } from '../../../Services/config/apiEndPoints';
const ServiceSelection = props => {
    let history = useHistory();
    let [serviceSelectionData, setServiceSelectionData] = useState([]);
    useEffect(() => {
        getServicesData();
    }, []);
    const getServicesData = () => {
        ApiCall(
            'GET',
            servicecatalogBaseURL + SERVICE_TYPES_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    setServiceSelectionData(apiData);
                }
            }
        });
    }
    const onHandleCard = (selectedId, serviceName) => {
        if (selectedId == '3') {
            history.push({
                pathname: `/CreateTransportationService/${selectedId}/${serviceName}`
            })
        }
        else {
            history.push({
                pathname: `/CreateResponseForm/${selectedId}/${serviceName}`
            })
        }
    }
    const handleQuotationHistory = () => {
        history.push("/QuotationHistory");
    }
    const handleContactSupport = () => {
        history.push("/ContactUs");
    }
    return (
        <div class="csoutercolor">
            <MetaDecorator title={TitleDescription.ServiceSelectionTitle} description={TitleDescription.ServiceSelectionDescription} />
            <Header tilesFetched={() => { }} />
            <div class="csnofullServiceSelection">
                <div id="csnobox1ServiceSelection">
                    <nav class="ServiceSelectionNavBar">
                        <div className="ServiceSelectionNavBarHeading">
                            <small id="ServiceSelectionNavBarHeadingValue"> Select Service Type</small>
                        </div>
                        <div id="ServiceSelectionNAcceptMobile"
                            className="ServiceSelectionNNavbarNameRight"
                            onClick={handleQuotationHistory}
                        >
                            <img src={quotationHistory} class=" mr-1 pb-1" id="ServiceSelectionNavBarRightHeadingImg" alt="" loading="lazy" />
                            <small id="ServiceSelectionCancelRequest" >Service Request History</small>
                        </div>
                    </nav>
                    <hr class="hr1" />
                    <nav class="ServiceSelectionNMobileNavbar">
                        <div className="ServiceSelectionNNavbarNameRight" onClick={handleQuotationHistory}>
                            <img src={quotationHistory} class=" mr-1 pb-1" id="ServiceSelectionNavBarRightHeadingImg" alt="" loading="lazy" />
                            <small id="ServiceSelectionCancelRequest" >Service Request History</small>
                        </div>
                    </nav>
                    <hr class="hrCDMobile" />
                    <div class="toppartServiceSelection">
                        <div class="ServiceSelectionOuterContainerDiv">
                            <div class="ServiceSelectionLeftOuterDiv">
                                {(serviceSelectionData?.map((name, index) => {
                                    return (
                                        <div class="ServiceSelectionLeftSideDiv" key={index} onClick={() => onHandleCard(name?.serviceId, name?.serviceName)}>
                                            {index < (serviceSelectionData?.length / 2) &&
                                                <>
                                                    <div class="ServiceSelectionWhiteContainerdiv">
                                                        <div class="ServiceSelectionLeftPartNumberDiv">
                                                            <small class="ServiceSelectionLeftPartNumber">{index + 1}</small>
                                                        </div>
                                                        <div class="ServiceSelectionRightPartContainerDiv">
                                                            <small class="ServiceSelectionHeading">{name?.serviceName}</small>
                                                            <div class="ServiceSelectionArrowDiv">
                                                                <img src={rightarrow} id="ServiceSelectionRightArrowImg" height="15" width="16" class="" alt="" loading="lazy" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    );
                                }))}
                            </div>
                            <div class="ServiceSelectionLeftOuterDiv">
                                {(serviceSelectionData?.map((name, index) => {
                                    return (
                                        <div class="ServiceSelectionRightSideDiv" key={index} onClick={() => onHandleCard(name?.serviceId, name?.serviceName)}>
                                            {index >= (serviceSelectionData?.length / 2) &&
                                                <>
                                                    <div class="ServiceSelectionWhiteContainerdiv">
                                                        <div class="ServiceSelectionLeftPartNumberDiv">
                                                            <small class="ServiceSelectionLeftPartNumber">{index + 1}</small>
                                                        </div>
                                                        <div class="ServiceSelectionRightPartContainerDiv">
                                                            <small class="ServiceSelectionHeading">{name?.serviceName}</small>
                                                            <div class="ServiceSelectionArrowDiv">
                                                                <img src={rightarrow} id="ServiceSelectionRightArrowImg" height="15" width="16" class="" alt="" loading="lazy" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    );
                                }))}
                            </div>
                        </div>
                        <div class="ServiceSelectionLowerNoteDiv">
                            <small class="ServiceSelectionLowerNote">Please contact <small class="ServiceSelectionRedNote" onClick={handleContactSupport}>Customer Support</small> to add new service here.</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cs2footer11ServiceSelection">
                <Footer />
            </div>
            <div class="cs2footer22ServiceSelection">
                <Footer2 />
            </div>
        </div>
    );
};
export default ServiceSelection; 